export const business = {
  legalName: 'Alliance Health Physicians',
  brandName: 'Alliance Health Physicians',
  addressLine1: '2000 Town Center, Suite 1900',
  addressLocality: 'Southfield',
  addressRegion: 'MI',
  addressCountry: 'US',
  postalCode: '48075',
  phoneDisplay: '(734) 542-5512',
  phoneE164: '+17345425512',
  faxDisplay: '(734) 540-1130',
  email: 'info@alliancehpg.com',
  geo: {
    latitude: 42.4733,
    longitude: -83.2219,
  },
  openingHours: {
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'] as const,
    opens: '08:00',
    closes: '17:00',
  },
  sameAs: [] as string[],
} as const;

export function addressSingleLine(): string {
  return `${business.addressLine1}, ${business.addressLocality}, ${business.addressRegion} ${business.postalCode}`;
}

export const organizationStructuredDescription =
  'Physician-owned hospital medicine group delivering 24/7 metric-driven care across hospitalist medicine, observation units, nursing home services, IM consultations, surgical specialty support, and transitional care — focused on cost reduction and patient outcomes.';
